module.exports = __webpack_public_path__ + "static/img/cont212.1534881.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont212.jpg
// module id = 4fiQ
// module chunks = 0